/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { Select } from '@react-three/postprocessing'
import { type JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

import { toLambert } from '@utils'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Sign3_1: Mesh
      Sign3_2: Mesh
      Sign3004: Mesh
      Sign3004_1: Mesh
      Sign3005: Mesh
      Sign3005_1: Mesh
      Sign3003_1: Mesh
      Sign3003_2: Mesh
      Sign6001: Mesh
      Sign6002: Mesh
    }
    materials: {
      ['Dark Wood']: MeshStandardMaterial
      Herbs: MeshStandardMaterial
      ['Light Wood']: MeshStandardMaterial
      ['Light Wood.001']: MeshStandardMaterial
    }
  }

type ArmProps = JSX.IntrinsicElements['group'] & { highlight?: boolean }

type WoodenSignDirectionsModelProps = JSX.IntrinsicElements['group'] & {
  armsProps?: ArmProps[]
}

export function WoodenSignDirectionsModel({
  armsProps = [],
  ...props
}: WoodenSignDirectionsModelProps) {
  const { nodes, materials } = useGLTF('/models/wooden-sign-directions.glb') as GLTFResult

  return (
    <group {...props}>
      <group scale={100}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sign3_1.geometry}
          material={toLambert(materials['Dark Wood'])}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sign3_2.geometry}
          material={toLambert(materials.Herbs)}
        />
      </group>

      {/* first sign */}
      <Select enabled={armsProps[0]?.highlight ?? false}>
        <group {...armsProps[0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign6002.geometry}
            material={toLambert(materials['Light Wood.001'])}
            position={[0, 0.19, 0.018]}
            scale={100}
          />
        </group>
      </Select>

      {/* second sign */}
      <Select enabled={armsProps[1]?.highlight ?? false}>
        <group {...armsProps[1]} position={[0, -0.137, 0]} scale={[130, 100, 100]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign3004.geometry}
            material={toLambert(materials['Dark Wood'])}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign3004_1.geometry}
            material={toLambert(materials['Light Wood'])}
          />
        </group>
      </Select>

      {/* third sign */}
      <Select enabled={armsProps[2]?.highlight ?? false}>
        <group {...armsProps[2]} scale={[155, 100, 100]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign3003_1.geometry}
            material={toLambert(materials['Dark Wood'])}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign3003_2.geometry}
            material={toLambert(materials['Light Wood'])}
          />
        </group>
      </Select>

      {/* fourth sign */}
      <Select enabled={armsProps[3]?.highlight ?? false}>
        <group {...armsProps[3]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign6001.geometry}
            material={toLambert(materials['Light Wood.001'])}
            position={[0, -0.383, 0.017]}
            scale={[200, 100, 100]}
          />
        </group>
      </Select>

      {/* fifth sign */}
      <Select enabled={armsProps[4]?.highlight ?? false}>
        <group {...armsProps[4]} position={[0, -0.189, 0]} scale={100}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign3005.geometry}
            material={toLambert(materials['Dark Wood'])}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Sign3005_1.geometry}
            material={toLambert(materials['Light Wood'])}
          />
        </group>
      </Select>
    </group>
  )
}

useGLTF.preload('/models/wooden-sign-directions.glb')
